// Demo fixtures served from /public/fixtures. Use the SamplePicker to load
// one without uploading real client data. Each fixture is anonymised and
// designed to exercise different parts of the pipeline.

export const SAMPLE_FIXTURES = [
  {
    id: 'acme-trading',
    name: 'Acme Trading & Logistics Ltd',
    summary: 'High-risk SME with BVI parent, Russia exposure, structured cash deposits',
    expected: 'Reject (Indefensible)',
    expectedColor: 'red',
    url: '/fixtures/sample-kyc-acme-trading.txt',
  },
  {
    id: 'northwind-imports',
    name: 'Northwind Imports Ltd',
    summary: 'Mid-risk importer with Jersey trust UBO gap and Turkey supplier exposure',
    expected: 'Remediate or Escalate (Borderline–Poor)',
    expectedColor: 'amber',
    url: '/fixtures/sample-kyc-northwind-imports.txt',
  },
  {
    id: 'bridgewater-consulting',
    name: 'Bridgewater Consulting Partners LLP',
    summary: 'UK consulting LLP, transparent ownership, dual-source screening; thin SoW evidence on UBOs claiming elite consulting careers + missing formal Ireland country-risk doc',
    expected: 'Escalate (Poor)',
    expectedColor: 'amber',
    url: '/fixtures/sample-kyc-bridgewater-consulting.txt',
  },
];

/**
 * Fetch a fixture's text content from /public.
 * @param {string} id
 * @returns {Promise<{ text: string, fileName: string, pages: null, fileType: 'txt', looksScanned: false }>}
 */
export async function loadFixture(id) {
  const fixture = SAMPLE_FIXTURES.find((f) => f.id === id);
  if (!fixture) throw new Error(`Unknown fixture: ${id}`);
  const res = await fetch(fixture.url);
  if (!res.ok) throw new Error(`Failed to load fixture ${id} (${res.status})`);
  const text = await res.text();
  return {
    text,
    fileName: `${fixture.id}.txt`,
    pages: null,
    fileType: 'txt',
    looksScanned: false,
  };
}
